import { Text } from '@cad-arc';
import { Tooltip } from './tooltip';


export const TextWithEllipsisAndTooltip: React.FC<{ text?: string }> = ({ text }) => {
    return text ? (
        <Tooltip overlay={text}>
            <Text
                style={{
                    whiteSpace: 'nowrap' as const,
                    overflow: 'hidden' as const,
                    textOverflow: 'ellipsis' as const,
                    cursor: 'default' as const,
                }}
            >
                {text}
            </Text>
        </Tooltip>
    ) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <></>
    );
};
